import React from "react";

import useChangeEmailConfirmationApiConsumer from "../consumers/useChangeEmailConfirmationApiConsumer";

export default function ChangeEmailConfirmationView() {
  useChangeEmailConfirmationApiConsumer();

  return <></>;
}
